import React from 'react';
import classnames from 'classnames';
import { EtchWidgets } from '@thd-olt-component-react/etch-widgets';
import {
  arrayOf, bool, shape, string
} from 'prop-types';
import { Col, Row } from '@thd-olt-component-react/grid';
import { SponsoredProductListing } from '@thd-olt-component-react/sponsored-content';
import { BulletList } from '../BulletList/BulletList';
import { InfoGuides } from '../InfoGuides/InfoGuides';
import { DISPLAY_MODE_ETCH, DISPLAY_MODE_REVJET, SALSIFY } from '../../constants';
import { shouldDisplayAdditionalResources } from '../../helpers';
import { RevJet } from '../RevJet/RevJet';
import { Salsify } from '../Salsify/Salsify';
import './desktop-content.scss';

const DesktopContent = (props) => {
  const {
    itemId,
    channel,
    description,
    additionalResources,
    richContent,
    hideRichContents,
    preview,
    bullets,
    shouldShowMore,
    showRichContentsOnly,
    returnMessage,
    showReturnMessage,
    showPla
  } = props;

  const desktopContentClasses = classnames({
    'desktop-content-wrapper--show-less': shouldShowMore
  });

  const etchContent = richContent?.content;
  const displayMode = typeof richContent?.displayMode === 'string'
    ? richContent?.displayMode.toLowerCase() : richContent?.displayMode;
  const revJet = displayMode === DISPLAY_MODE_REVJET;
  const etch = !!displayMode
    && displayMode.startsWith(DISPLAY_MODE_ETCH);
  const richContentSource = richContent?.richContentSource;
  const salsify = richContentSource === SALSIFY;
  const salsifyRichContent = richContent?.salsifyRichContent;
  const displayAdditionalResources = !!(
    additionalResources
    && shouldDisplayAdditionalResources(additionalResources)
    && !showRichContentsOnly
  );

  // TODO: Clean this up, bad pattern.
  const thdGlobalDefined = typeof window !== 'undefined'
   && typeof window.THD_GLOBAL !== 'undefined'
   && window.THD_GLOBAL;
  const env = thdGlobalDefined.API_PROXY_ENV_NAME === '' ? 'prod' : 'qa';

  return (
    <div className="desktop-content-wrapper">
      {revJet && !hideRichContents
        && <RevJet itemId={itemId} envSpace={env} parentId="revJet-desktop-wrapper" />}
      {salsify && !revJet && !hideRichContents
        && <Salsify salsifyRichContent={salsifyRichContent} parentId="salsify-desktop-wrapper" />}
      <Row className={desktopContentClasses}>
        {(!salsify && !revJet && etch && !hideRichContents)
          && <EtchWidgets content={etchContent} /> }
        <Col fallback={displayAdditionalResources ? '7' : '12'} className="desktop-content-wrapper__left-col">
          <Row className="desktop-content-wrapper__main-description">
            {!showRichContentsOnly ? description : null}
            {bullets && bullets.length
              && <BulletList bullets={bullets} margin isMobile={false} />}
          </Row>
        </Col>
        {displayAdditionalResources && (
          <Col fallback="5">
            <InfoGuides
              additionalResources={additionalResources}
              channel={channel}
              returnMessage={returnMessage}
              showReturnMessage={showReturnMessage}
            />
            {showPla && (
              <div className="sponsored-pla-product-overview-wrapper">
                <SponsoredProductListing
                  pageContext={
                    {
                      label: 'product-overview',
                      data: { itemId }
                    }
                  }
                />
              </div>
            )}
          </Col>
        )}
      </Row>
    </div>
  );
};

const areEqual = (prevProps, nextProps) => {
  return prevProps.itemId === nextProps.itemId
  && prevProps.returnMessage === nextProps.returnMessage;
};

DesktopContent.displayName = 'DesktopContent';

DesktopContent.propTypes = {
  additionalResources: shape({
    infoAndGuides: arrayOf(shape({
      name: string,
      url: string
    })),
    diyProjects: arrayOf(shape({
      contentType: string,
      name: string,
      url: string
    })),
    installationAndRentals: arrayOf(shape({
      contentType: string,
      name: string,
      url: string
    })),
  }),
  channel: string.isRequired,
  description: string.isRequired,
  hideRichContents: bool,
  preview: bool,
  richContent: shape({
    content: string,
    displayMode: string,
    url: string
  }),
  bullets: arrayOf(shape({})),
  shouldShowMore: bool,
  showRichContentsOnly: bool,
  returnMessage: string,
  showReturnMessage: bool,
  itemId: string.isRequired,
  showPla: bool
};

DesktopContent.defaultProps = {
  additionalResources: null,
  hideRichContents: false,
  preview: false,
  richContent: {},
  shouldShowMore: false,
  showRichContentsOnly: false,
  bullets: [],
  returnMessage: '',
  showReturnMessage: false,
  showPla: false
};

export default React.memo(DesktopContent, areEqual);
